import React from "react";

const SvgIcon: React.FC<{
  children: React.ReactNode;
  size?: number;
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
  strokeLinecap?: "round" | "butt" | "square";
  strokeLinejoin?: "round" | "miter" | "bevel";
  className?: string;
}> = ({
  children,
  size = 27,
  fill = "none",
  stroke = "currentColor",
  strokeWidth = 1.5,
  strokeLinecap = "round",
  strokeLinejoin = "round",
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill}
    stroke={stroke}
    strokeWidth={strokeWidth}
    strokeLinecap={strokeLinecap}
    strokeLinejoin={strokeLinejoin}
    className={className}
    style={{
      width: size,
      height: size,
      minWidth: size,
      minHeight: size,
      flexShrink: 0,
    }}
  >
    {children}
  </svg>
);

const HomeIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M5 12l-2 0l9 -9l9 9l-2 0" />
    <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" />
    <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" />
  </SvgIcon>
);

const SubmitTicketIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={1.5} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M4 8v8" />
    <path d="M4 8a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2" />
    <path d="M20 10a2 2 0 0 0 0 4" />
    <path d="M4 10a2 2 0 0 1 0 4" />
    <path d="M10 8v8" strokeDasharray="2 2" />
  </SvgIcon>
);

const MyTicketIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={1.5} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M5.5 6.5h13a1.5 1.5 0 0 1 1.5 1.5v1.5a1 1 0 0 0 -1 1a1 1 0 0 0 1 1v1.5a1.5 1.5 0 0 1 -1.5 1.5h-13a1.5 1.5 0 0 1 -1.5 -1.5v-1.5a1 1 0 0 0 1 -1a1 1 0 0 0 -1 -1v-1.5a1.5 1.5 0 0 1 1.5 -1.5z" />
    <path d="M5.5 11.5h13a1.5 1.5 0 0 1 1.5 1.5v1.5a1 1 0 0 0 -1 1a1 1 0 0 0 1 1v1.5a1.5 1.5 0 0 1 -1.5 1.5h-13a1.5 1.5 0 0 1 -1.5 -1.5v-1.5a1 1 0 0 0 1 -1a1 1 0 0 0 -1 -1v-1.5a1.5 1.5 0 0 1 1.5 -1.5z" />
    <path d="M12 7v3" />
    <path d="M12 13v3" />
  </SvgIcon>
);

const SubmitContentIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={1.5} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M4 20h16" />
    <path d="M4 20v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16" />
    <path d="M8 6h6" />
    <path d="M8 10h8" />
    <path d="M8 14h4" />
    <path d="M18.5 17.5l2 -2" />
    <path d="M20.5 15.5a1 1 0 0 0 -1.415 -1.415l-6.585 6.585v2h2l6.585 -6.585a1 1 0 0 0 0 -1.415z" />
  </SvgIcon>
);

const MyContentIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={1.5} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M8 4h-4a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h4" />
    <path d="M8 4v16" />
    <path d="M8 4h10a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2z" />
    <path d="M18 4v4h4" />
    <path d="M12 9h4" />
    <path d="M12 13h2" />
  </SvgIcon>
);

const SearchIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={2} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
    <path d="M21 21l-6 -6" />
  </SvgIcon>
);

const HighDefinitionIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={2} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M5 9v6" />
    <path d="M9 9v6" />
    <path d="M5 12h4" />
    <path d="M13 15v-6h2.5a2 2 0 0 1 0 4h-2.5" />
    <path d="M19 9v6" />
  </SvgIcon>
);

const HDTicketIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={1.5} strokeLinejoin="round" strokeLinecap="round" {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M5 3.5 A1.5 1.5 0 0 0 5 6.5" />
    <path d="M5 9.5 A1.5 1.5 0 0 0 5 12.5" />
    <path d="M5 15.5 A1.5 1.5 0 0 0 5 18.5" />
    <path d="M12 3.5 A1.5 1.5 0 0 0 12 6.5" />
    <path d="M12 9.5 A1.5 1.5 0 0 0 12 12.5" />
    <path d="M12 15.5 A1.5 1.5 0 0 0 12 18.5" />
    <path d="M20 9.5 A1.5 1.5 0 0 0 20 6.5" />
    <path d="M20 17.5 A1.5 1.5 0 0 0 20 14.5" />
    <path d="M5 3.5 L20 3.5 L20 6.5 A1.5 1.5 0 0 1 21.5 8 A1.5 1.5 0 0 1 20 9.5 L20 14.5 A1.5 1.5 0 0 1 21.5 16 A1.5 1.5 0 0 1 20 17.5 L20 20.5 L5 20.5" />
    <path d="M7.5 7.5 L10.5 7.5" />
    <path d="M7.5 11 L10.5 11" />
    <path d="M7.5 14.5 L10.5 14.5" />
    <path d="M14.5 7.5 L17.5 7.5" />
    <path d="M14.5 11 L17.5 11" />
    <path d="M14.5 14.5 L17.5 14.5" />
  </SvgIcon>
);

const HDContentIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={1.5} strokeLinejoin="round" strokeLinecap="round" {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M4 2 L16 2 L16 16 L4 16 Z" />
    <path d="M16 6 L20 6 L20 20 L8 20 L8 16" />
    <text 
      x="10" 
      y="11" 
      textAnchor="middle" 
      fill="currentColor" 
      stroke="none" 
      fontSize="7" 
      fontWeight="bold"
      fontFamily="Arial, sans-serif"
    >
      HD
    </text>
    <path d="M6 14 L14 14" />
  </SvgIcon>
);

const BookmarkIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={2} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M5 5a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14l-7 -3l-7 3v-14z" />
  </SvgIcon>
);

const ProfileIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={2} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
    <path d="M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
    <path d="M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855" />
  </SvgIcon>
);

const DashboardIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={2} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M4 4h6v8h-6z" />
    <path d="M4 16h6v4h-6z" />
    <path d="M14 12h6v8h-6z" />
    <path d="M14 4h6v4h-6z" />
  </SvgIcon>
);

const UserAdminIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={2} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
    <path d="M6 21v-2a4 4 0 0 1 4 -4h4" />
    <path d="M19 16v6" />
    <path d="M22 19l-3 -3l-3 3" />
  </SvgIcon>
);

const ChartBarIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={2} fill="none" {...props}>
    <path d="M3 12h4v9h-4z" />
    <path d="M10 8h4v13h-4z" />
    <path d="M17 4h4v17h-4z" />
  </SvgIcon>
);

const PhoneIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={2} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" />
  </SvgIcon>
);

const DatabaseIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={2} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 6m-8 0a8 3 0 1 0 16 0a8 3 0 1 0 -16 0" />
    <path d="M4 6v6a8 3 0 0 0 16 0v-6" />
    <path d="M4 12v6a8 3 0 0 0 16 0v-6" />
  </SvgIcon>
);

const BooksIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={1.5} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M6 4l-2 15h4l2 -15z" />
    <path d="M4 19h4" />
    <path d="M10 4l0 15a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2l0 -15a2 2 0 0 0 -2 -2h-2a2 2 0 0 0 -2 2z" />
    <path d="M10 19h6" />
    <path d="M17 5l-1 14h4l1 -14a2 2 0 0 0 -2 -2h-0.5a2 2 0 0 0 -1.5 2z" />
    <path d="M16 19h4" />
  </SvgIcon>
);

const ContentMaintenanceIcon = (props: {
  size?: number;
  className?: string;
}) => (
  <SvgIcon strokeWidth={1.5} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M5 4l-1 16h3l1 -16z" />
    <path d="M4 20h3" />
    <path d="M10 4v14a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-14a2 2 0 0 0 -2 -2h-2a2 2 0 0 0 -2 2z" />
    <path d="M10 20h6" />
    <path d="M17 3l4 4" />
    <path d="M19 5l-7.5 7.5l-1.5 0l0 -1.5l7.5 -7.5" />
    <path d="M17 3l2 2" />
  </SvgIcon>
);

const LogoutIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={2} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />
    <path d="M9 12h12l-3 -3" />
    <path d="M18 15l3 -3" />
  </SvgIcon>
);

const AccountIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={2} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
    <path d="M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
    <path d="M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855" />
  </SvgIcon>
);

const NotificationIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={2} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3l1 1v1h-14v-1l1 -1v-3a7 7 0 0 1 4 -6" />
    <path d="M9 17v1a3 3 0 0 0 6 0v-1" />
  </SvgIcon>
);

const ArrowDownIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={2} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M6 9l6 6l6 -6" />
  </SvgIcon>
);

const DeleteIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={2} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M4 7l16 0" />
    <path d="M10 11l0 6" />
    <path d="M14 11l0 6" />
    <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
    <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
  </SvgIcon>
);

const InsertPhotoIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={2} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M15 8h.01" />
    <path d="M4 8m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
    <path d="M4 16l4.586 -4.586a2 2 0 0 1 2.828 0l5.586 5.586" />
  </SvgIcon>
);

const FilledBookmarkIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon fill="currentColor" strokeWidth={0} {...props}>
    <path d="M5 5a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14l-7 -3l-7 3v-14z" />
  </SvgIcon>
);

const UnfilledBookmarkIcon = (props: { size?: number; className?: string }) => (
  <SvgIcon strokeWidth={2} {...props}>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M5 5a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14l-7 -3l-7 3v-14z" />
  </SvgIcon>
);

const Icons = {
  homeIcon: <HomeIcon />,
  ticketInput: <SubmitTicketIcon />,
  contentInput: <SubmitContentIcon />,
  myTicket: <MyTicketIcon />,
  myContent: <MyContentIcon />,
  search: <SearchIcon />,
  hdTicket: <HDTicketIcon />, 
  hdContent: <HDContentIcon />,
  favorite: <BookmarkIcon />,
  profile: <ProfileIcon />,
  dashboard: <DashboardIcon />,
  userAdmin: <UserAdminIcon />,
  powerbi: <ChartBarIcon />,
  contact: <PhoneIcon />,
  contentCollector: <BooksIcon />,
  contentMaintenanceIcon: <ContentMaintenanceIcon />,
  account: <LogoutIcon />,
  logout: <AccountIcon />,
  notification: <NotificationIcon />,
  arrowDown: <ArrowDownIcon />,
  delete: <DeleteIcon />,
  insertImage: <InsertPhotoIcon />,
  filledBookMark: <FilledBookmarkIcon />,
  unfilledBookMark: <UnfilledBookmarkIcon />,
};

export default Icons;